const initialStates = {
  edit_email_notifications: {
    rcpt: '',
    subject: '',
    body: '',
  },
  push_notification_template: {
    title: '',
    content: '',
    page: 'home',
    user_list: '',
    push_when: 'now',
    push_at: '',
    group_ids: [],
  },
  access_token_edit: {
    uid: '',
    revoke_api_access: false,
  },
  app_version: {
    version: '',
    force_update: false,
  },
  reply_message: {
    subject: '',
    body: '',
  },
  store_message: {
    subject: '',
    body: '',
  },
  playground: {
    spinner: 1,
    range_slider: 75,
  },
  registration: {
    outlet_validation: {
      customer_number: '',
      eircode_or_passcode: ''
    },
  },
  yourStore: {
    customer_number: '',
    updated_name: '',
    updated_address_1: '',
    updated_address_2: '',
    updated_address_3: '',
    updated_town: '',
    updated_country: '',
    updated_eircode: '',
    dont_know_eircode: false
  },
  login: {
    login: '',
    password: ''
  },
  resetPW: {
    step1: {
      email: '',
      mobile: '',
    },
    step2: {
      pin: '',
    },
    step3: {
      answer1: '',
      answer2: ''
    },
    step4: {
      password: '',
      password_confirmation: ''
    },
  },
  my_staff: {
    outlet_id: '',
  },
  staff_member: {
    title: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    outlet_id: '',
    permission_ids: {},
    agreed: false,
    is_champion: false
  },
  store: {
    staff_member: {
      title: '',
      first_name: '',
      last_name: '',
      email: '',
      mobile: '',
      outlet_id: '',
      permission_ids: {},
    }
  },
  store_summary: [],
  about_you: {
    marketing_consent: {
      marketing_accepted: null,
      marketing_accepted_confirm: null,
    },
    user: {
      title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      gender: 'male',
      marketing_accepted: null,
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: true,
      comms_mobile: true,
      email: '',
      mobile: '',
      password: '',
      password_confirmation: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: '',
        },
        {
          security_question_id: '',
          answer: '',
        }
      ],
      t_cs1: false,
      t_cs2: true,
    }
  },
  updatePw: {
    user: {
      current_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  updateSecQ: {
    user: {
      current_password: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: ''
        },
        {
          security_question_id: '',
          answer: ''
        }
      ]
    },
    owner: {
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: '',
          id: ''
        },
        {
          security_question_id: '',
          answer: '',
          id: ''
        }
      ]
    }
  },
  my_profile: {
    personal_address_1: '',
    personal_address_2: '',
    personal_address_3: '',
    personal_address_4: '',
    personal_eircode: '',
    billing_address_1: '',
    billing_address_2: '',
    billing_address_3: '',
    billing_address_4: '',
    billing_eircode: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: '',
    marketing_accepted: false,
  },
  order: {
    confirm: {
      outlet_id: '',
      your_reference: '',
      line_items_attributes: []
    }
  },
  contact_us: {
    title: '',
    name: '',
    store_name: '',
    email: '',
    telephone: '',
    type_of_enquiry: '',
    message: ''
  },
  contact_us_team: {
    from: '',
    subject: '',
    message: '',
  },
  admin_my_profile: {
    first_name: '',
    last_name: '',
    title: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: ''
  },
  admin_edit_user: {
    title: '',
    first_name: '',
    last_name: '',
    usergroup: '',
    comms_email: false,
    email: '',
    status: '',
    locked: 'no'
  },
  admin_welcome: {
    password: '',
    password_confirmation: '',
    t_cs1: false,
    t_cs2: false,
    invitation_token: '',
    security_answers_attributes: [
      {
        security_question_id: '',
        answer: '',
      },
      {
        security_question_id: '',
        answer: '',
      }
    ],
  },
  admin_usergroup: {
    name: '',
    permission_ids: {}
  },
  admin_level: {
    name: '',
    next_level: {},
    active: 'true'
  },
  admin_update_level: {
    outlet_id: '',
    new_level_id: '',
    reason: ''
  },
  admin_navigationlink: {
    name: '',
    group_ids: [],
    url: '',
    permission_ids: {},
    groups: {}
  },
  admin_notification_edit: {
    event: '',
    to_associated_user: 'true',
    custom_to: '',
    email: false,
    email_subject: '',
    email_body: '',
    sms: false,
    sms_body: '',
    site_message: false,
    site_body: ''
  },
  admin_user: {
    details: {
      title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: false,
      comms_mobile: false,
      email: '',
      mobile: '',
      status: '',
      account_locked: '',
      thirty_day_exception: '',
    },
    edit: {
      title: '',
      first_name: '',
      last_name: '',
      comms_email: 'true',
      email: '',
      status: '',
      account_locked: '',
      user_group_id: '',
      employee_code: '',
      ror_code: '',
      rdr_code: '',
      rbm_code: '',
      ffde_code: '',
      am_code: '',
      abm_code: '',
      abm_relief: {
        abm_relief_user_id: '',
        start_date: '',
        end_date: ''
      }
    }
  },
  page: {
    name: '',
    page_template: '',
    login_required: ''
  },
  admin_delink: {
    delink_date: '',
    delink_reason: '',
    outlet: '',
    supress_notification: false,
  },
  admin_category: {
    name: ''
  },
  admin_brand: {
    name: '',
    categories: [],
    status: ''
  },
  admin_outlet_view: {
    auto_redeem: false,
    voucher_denomination_id: '',
    voucher_type_id: '',
    reward_markup: 99,
    use_delivery_address: false,
    groups: [],
    invalidate_scans: {
      staff_member: '',
      invalidate_from_date: '',
      invalidate_to_date: ''
    }
  },
  admin_product_save: {
    name: '',
    status: 'ACTIVE',
    special_new: true,
    special_featured: false,
    special_reward: true,
    special_sell_it: false,
    special_price_it: false,
    exclude_from_marketing: false,
    hyperlink: '',
    sku: '',
    product_eans: '',
    category_id: '',
    brand_id: '',
    group_ids: [],
    sell_it_group_ids: [],
    price_it_group_ids: [],
    all_groups: false,
    all_groups_sell_it: false,
    all_groups_price_it: false,
    rsp: '',
    outer_price: 0,
    units_per_outer: 0,
    tar: '',
    nicotine: '',
    flavour: '',
    max_per_order: 0,
    product_exceptions: [],
    stock_status: 'In Stock',
    photo: '',
    variant: '',
  },
  admin_group_save: {
    name: '',
  },
  admin_feature_toggle_save: {
    name: '',
    description: '',
    enabled: 'false'
  },
  admin_ppc: {
    settings: {
      autoload_date: '',
      autoload_dates: [],
      kyc_limit_euro: '',
      load_fee_percent: '',
      points_per_euro: '',
      ppc_management_url: '',
      postcodeplan_redemption_date: '',
      postcodeplan_redemption_frequency: '',
    },
    management: {
      user: {
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        address_1: '',
        address_2: '',
        town: '',
        county: '',
        eircode: '',
        kyc_status: '',
        email: '',
        mobile: ''
      },
      load: {
        points: 0,
        value: 0,
        status: ''
      },
      manual_load: {
        points: 0,
        value: 0,
      }
    }
  },
  admin_damaged_barcode_submission_view: {
    product_code: '',
    outer_code: '',
  },
  admin_decline_scan_orverride_dialog: {
    decline_reason: ''
  },
  admin_damaged_barcode_dialog: {
    decline_reason: ''
  },
  ppc_management_url: '',
  incentives: {
    name: '',
    image: '',
    start_date: '',
    end_date: '',
    current_date_before_start_date: false,
    submission_grace_period: '',
    kind: '',
    incentive_type: '',
    target: '',
    default_target: '',
    maximum_points: '',
    points_to_target: '',
    points_to_target_2: '',
    points_after_target: '',
    display_from: '',
    display_to: '',
    product_ids: [],
    percentage_calculate_from: '',
    percentage_calculate_to: '',
    bonus_points_enabled: 'false',
    bonus_points_to_target: '',
    bonus_points_to_target_2: '',
    bonus_points_after_target: '',
    bonus_points_to: '',
    bonus_points_from: '',
    bonus_link: '',
  },
  admin_staff_reward: {
    settings: {
      point_per_euro: '',
      reward_markup: '',
      available_vouchers: [],
      autoredemption_date: '',
      autoredemption_dates: [],
      postcodeplan_redemption_date: '',
      postcodeplan_redemption_frequency: '',
    }
  },
  admin_news: {
    category: {
      name: ''
    },
    article: {
      title: '',
      title_text_colour: 'Red',
      news_category_id: 0,
      status: '',
      display_from_date: '',
      display_to_date: '',
      display_location: '',
      featured: '',
      permission_ids: [],
      linked_article_ids: [],
      group_ids: [],
      tags: []
    }
  },
  admin_files: {
    upload: {
    },
    edit: {
      name: ''
    }
  },
  admin_data_import: {
    file: ''
  },
  points_expiry: {
    day: '',
    month: ''
  },
  user_point: {
    value: '',
    description: '',
    owner: '',
    outlet: '',
    point_pot: ''
  },
  home_page_carousel: {
    position: '',
    title: '',
    text: '',
    text_color: 'White',
    button_color: 'Red',
    button_text_color_when_hover: '',
    button_label: '',
    image: '',
    mobile_image: '',
    button_link: '',
    button_article_link: '0',
    display_from_date: '',
    display_to_date: '',
    text_alignment: 'left',
    permission_ids: {},
    all_groups: false,
    group_ids: []
  },
  home_page_carousel_setting: {
    slide_speed: ''
  },
  personal_rewards: {
    first_name: '',
    last_name: '',
    email: '',
    accept_terms: false
  },
  staff_rewards: {
    auto_redeem: false,
    voucher_type_id: '',
    voucher_denomination_id: ''
  },
  tile: {
    link: '',
    label: '',
    button_color: '',
    button_text_color_when_hover: '',
    default_image: '',
    image: ''
  },
  point_statement: {
    outlet_id: '',
    transaction_type: '',
    date_from: '',
    date_to: '',
  },
  team_welcome: {
    password: '',
    password_confirmation: '',
    t_cs1: false,
    t_cs2: false,
    invitation_token: '',
    security_answers_attributes: [
      {
        security_question_id: '',
        answer: '',
      },
      {
        security_question_id: '',
        answer: '',
      }
    ],
  },
  admin_campaign_save: {
    name: '',
    start_date: '',
    end_date: '',
    image: '',
    campaign_type: 'tobacco'
  },
  admin_submission: {
    number_of_outers: '',
    audit_completed: false,
    audit_amount: '',
    outlet_id: '',
    incentive_id: '',
    postcodeplan_objectives_id: '',
    proof_type: '',
    decline_reason: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: [],
    outlet_name: '',
    outlet_code: '',
    notes: '',
    status: null,
    wholesaler_id: '',
    number_of_packs_solds: [],
    audit_amounts: [],
    receipt_id: ''
  },
  stock_it: {
    name: '',
    description: '',
    image: '',
    groups: [],
    levels: {},
    maximum_points: '',
    start_date: '',
    end_date: '',
    display_from_date: '',
    display_to_date: '',
    current_date_before_start_date: false
  },
  price_it: {
    name: '',
    description: '',
    image: '',
    groups: [],
    product_ids: [],
    levels: {},
    maximum_points: '',
    current_date_before_start_date: false
  },
  display_it: {
    name: '',
    image: '',
    groups: [],
    product_ids: [],
    levels: {},
    maximum_points: '',
  },
  postcode_plan: {
    name: '',
    description: '',
    start_date: '',
    end_date: '',
    postcodes: [],
    zones: [],
    groups: [],
    products: [],
    opt_in_bonus_points: '',
    administration_validation_threshold: '',
    display_from_date: '',
    display_to_date: '',
    opt_in_bonus_outlets: '',
    category_points: {},
    thresholds: {},
  },
  submission: {
    number_of_outers: '',
    outlet_id: '',
    incentive_id: '',
    proof_type: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: [],
    store_name_confirm: '',
    dates_confirm: '',
    evidence_confirm: '',
    sell_it_objectives: [],
    wholesaler_id: ''
  },
  pointsType: {
    pointsType: '',
    icon_uid: '',
    name: '',
    link: {},
    news_feed: false
  },
  postcodePlanObjective: {
    outlet_id: '',
    postcodeplan_objectives_id: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: []
  },
  marketingConsents: []
};

const pushNotificationTemplate = initialStates.push_notification_template;

export { pushNotificationTemplate, initialStates };

export default initialStates;



// WEBPACK FOOTER //
// ./src/initialStates.js